import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase-config";
import { collection, getDocs, query, where } from "firebase/firestore";
import loginBg from '../assets/svg/login.svg';
import "./EmployeeDashboard.css";

function EmployeePayslips() {
  const navigate = useNavigate();
  const [employeeName, setEmployeeName] = useState("");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const employeeQuery = query(
          collection(db, "employees"),
          where("email", "==", user.email)
        );
        const querySnapshot = await getDocs(employeeQuery);
        if (!querySnapshot.empty) {
          const employeeData = querySnapshot.docs[0].data();
          setEmployeeName(`${employeeData.prenom} ${employeeData.nom}`);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="dashboard-board-container" style={{
      minHeight: '100vh',
      background: `url(${loginBg}) center/cover no-repeat`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0
    }}>
      <div className="dashboard-board-content" style={{
        background: 'rgba(255,255,255,0.85)',
        borderRadius: 20,
        padding: 32,
        boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
        minWidth: 320,
        maxWidth: 400,
        minHeight: 340,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative'
      }}>
        {/* Croix de fermeture */}
        <button onClick={() => navigate("/dashboard-board")}
          style={{position: 'absolute', top: 18, right: 18, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: '#333', width: 36, height: 36, lineHeight: 1, zIndex: 2}}
          aria-label="Fermer"
        >
          ×
        </button>

        <h2 style={{marginBottom: 8}}>Bulletins de Paie</h2>
        {/* {employeeName && (
          <div style={{ fontSize: 16, color: '#555', marginBottom: 28 }}>{employeeName}</div>
        )} */}
        <div style={{marginBottom: 32, minHeight: 80, width: '100%', textAlign: 'left', padding: '0 16px'}}>
          <p style={{marginBottom: 24, lineHeight: 1.5, color: '#333'}}>
            Pour récupérer vos bulletins de paie, cliquez sur le bouton ci-dessous et renseignez votre email et votre mot de passe pour accéder au tableau de bord salarié de notre partenaire BestPaye.
          </p>
          <button
            className="payslip"
            style={{marginBottom: 16}}
            onClick={() => window.open('https://salaries.bestpaye.fr/login', '_blank', 'noopener,noreferrer')}
          >
            Accéder à BestPaye
          </button>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', gap: 16, width: '100%'}}>
          <button className="dashboard-back" onClick={() => navigate("/dashboard-board")}>Retour</button>
        </div>
      </div>
    </div>
  );
}

export default EmployeePayslips; 